import React from "react";
import Navbar from "./components/navbar/navbar"
import styles from "./app.css"
function App() {
  return (
    <body>
    <div className={styles.container}>
      <Navbar/>
    </div>
    </body>
  );
}

export default App;
